export default {
  getCurrentUserInfo(state) {
    return state.currentUserInfo;
  },
};
